import PersonalInformation from "../../../../features/TraxxionProfile/sections/Personal/PersonalInformation";
import KeyDates from "../../../../features/TraxxionProfile/sections/Personal/KeyDates";
import CompanyInformation from "../../../../features/TraxxionProfile/sections/Personal/CompanyInformation";
import Address from "../../../../features/TraxxionProfile/sections/Personal/Address";
import CustomFields from "../../../../features/TraxxionProfile/sections/Personal/CustomFields";

function Personal({ user }: any) {
    return (
        <div className="tw-flex tw-flex-col tw-gap-2">
            <PersonalInformation user={user} />
            <KeyDates user={user} />
            <CompanyInformation user={user} />
            <Address user={user} />
            <CustomFields user={user} />
        </div>
    );
}

export default Personal;
